import PropTypes from 'prop-types'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-gallery`
export const MODAL_BASE_CLASS = `${BASE_CLASS}-modal`
export const GALLERY_URL_PARAM = 'gallery'

export const MEDIA_TYPES = {
  IMAGE: 'image',
  VIDEO: 'video',
  PLACEHOLDER: 'placeholder'
}

export const mediaItemShape = PropTypes.shape({
  type: PropTypes.oneOf(Object.values(MEDIA_TYPES)).isRequired,
  src: PropTypes.string,
  poster: PropTypes.string,
  provider: PropTypes.string,
  autoPlay: PropTypes.bool
})

// Width of the featured image = 2 thumbnail columns + 1 gap.
// Used as the horizontal scroll step so each arrow click advances exactly one featured-image width.
export const DESKTOP_SCROLL_STEP = 571

// Both mirror the `-track` rule in index.scss: `gap: $m-s` and
// `grid-auto-columns: calc((#{$w-mt-detail-new-gallery-main} - #{$m-s}) / 2)` = (571 - 4) / 2.
// Keep them in sync if the grid gap ever changes — the scroll maths reads these, not the DOM.
export const DESKTOP_THUMB_COL_WIDTH = 283.5
export const DESKTOP_GRID_GAP = 4

// 1 featured (spans 2×2) + 6 thumbnails fills the initial visible desktop viewport.
export const DESKTOP_MIN_CELLS = 7

// Mirrors `grid-template-rows: repeat(2, 1fr)` in index.scss — cells fill column-first, 2 per column.
export const DESKTOP_GRID_ROWS = 2

// An arrow click advances 3 thumbnail columns (measured from the DOM, so it stays right at any zoom).
export const DESKTOP_ARROW_STEP_COLS = 3

// Extra horizontal margin beyond the viewport for which desktop cells are still mounted.
export const DESKTOP_PRELOAD_PX = 400

// Slides within this many positions of the current one are mounted; the rest stay empty.
export const ADJACENT_RADIUS = 1

// Minimum delay between two wheel-driven slide changes in the fullscreen modal.
export const WHEEL_COOLDOWN_MS = 400

export const IMAGE_WIDTH_DESKTOP = DESKTOP_SCROLL_STEP
export const IMAGE_WIDTH_MOBILE = 400

export const MODAL_IMAGE_WIDTH_DESKTOP = 713
export const MODAL_IMAGE_WIDTH_MOBILE = 407

export const VIDEO_POSITIONS = {
  FIRST: 'FIRST',
  LAST: 'LAST'
}
